  document.querySelectorAll('.animate-marquee-group').forEach(card => {
    const inner = card.querySelector('.marquee-inner');
    const text = inner?.querySelector('.offer-text');

    if (!card || !inner || !text) return;

    const clone = text.cloneNode(true);
    inner.appendChild(clone);
  });